const initialState = {
  loading: false,
  success: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'MAIL_CONFIRMATION_REQUEST': {
      return {...initialState, loading: true};
    }
    case 'MAIL_CONFIRMATION_SUCCESS': {
      return {...state, success: true, loading: false};
    }
    case 'MAIL_CONFIRMATION_FAILURE': {
      return {...state, error: action.error, loading: false};
    }
    default:
      return state;
  }
}
